import { render, staticRenderFns } from "./SubmissionMonaco.vue?vue&type=template&id=6757beb0"
import script from "./SubmissionMonaco.vue?vue&type=script&lang=js"
export * from "./SubmissionMonaco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports